// Functions
const source = () => {
    if (document.referrer.search('https?://(.*)google.([^/?]*)') === 0) {
        return 'Google';
    } else if (document.referrer.search('https?://(.*)bing.([^/?]*)') === 0) {
        return 'Bing';
    } else if (document.referrer.search('https?://(.*)yahoo.([^/?]*)') === 0) {
        return 'Yahoo';
    } else if (document.referrer.search('https?://(.*)facebook.([^/?]*)') === 0) {
        return 'Facebook';
    } else if (document.referrer.search('https?://(.*)twitter.([^/?]*)') === 0) {
        return 'Twitter';
    } else {
        return 'Other';
    }
}
//console.log(source());
//mixpanel.register_once({"Source": source()});
//mixpanel.people.set_once({"Source": source()});

//<-- Events -->//
// Site_visited
// This event tracks when an user start a session on the site
function siteVisited() {
  var sessionVisit = sessionStorage.getItem('siteVisitedMP');
  if (sessionVisit != 'startSessionMP') {
    console.log('site visited');
    sessionStorage.setItem('siteVisitedMP', 'startSessionMP');
    mixpanel.track('Site_visited',{'Page_title': document.title});
  } else {
    pageViewed();
  }
}

// Landing_visited
// This event tracks when an user start a session in to a landing page
function landingVisited() {
  var sessionLandingVisit = sessionStorage.getItem('landingVisitedMP');
  if (sessionLandingVisit != 'startSessionLandingMP') {
    sessionStorage.setItem('landingVisitedMP', 'startSessionLandingMP');
    mixpanel.track('Landing_visited',{'Page_title': document.title});
  } else {
    pageViewed();
  }
}

// Page_viewed
// This event tracks when an user view any page
function pageViewed() {
  mixpanel.track('Page_viewed',{'Page_title': document.title});
}

// Time_tracker_started
// This event tracks when the user scrolls 25%, 50%, 75%, or 100% on the page.
// window.addEventListener("scroll", () => {
//     let scrollTop = window.scrollY;
//     let docHeight = document.body.offsetHeight;
//     let winHeight = window.innerHeight;
//     let scrollPercent = scrollTop / (docHeight - winHeight);
//     let scrollPercentRounded = Math.round(scrollPercent * 100);
//     if(scrollPercentRounded == 25) {
//         mixpanel.track('Time_tracker_started',{'25%_scroll_reached': true});
//     } else if(scrollPercentRounded == 50) {
//         mixpanel.track('Time_tracker_started',{'50%_scroll_reached': true});
//     } else if(scrollPercentRounded == 75) {
//         mixpanel.track('Time_tracker_started',{'75%_scroll_reached': true});
//     } else if(scrollPercentRounded == 100) {
//         mixpanel.track('Time_tracker_started',{'100%_scroll_reached': true});
//     }
// });

// Account_creation_started
// This event tracks when the user presses the Create Account link
window.addEventListener('load', (e) => {
    var els = document.querySelectorAll('.yotpo-register-link');
    for(var i = 0; i < els.length; i++) {
        els[i].addEventListener('click', (event) => {
            accountCreationStarted({'Previous_action':'rewards'});
        });
    }
});
function accountCreationStarted(data) {
    mixpanel.track('Account_creation_started',data);
}

// Account_creation_completed
// This event tracks when the user complete the proccess of create an account
document.addEventListener('DOMContentLoaded', (e) => {
    var form = document.querySelectorAll('#create-customer form');
    var email = document.querySelectorAll('#create-customer form input#email');
    if(form.length > 0) {
        form[0].addEventListener('submit', (event) => {
            localStorage.setItem('registered_email', email[0].value);
        });
    }
});

function accountCreationCompleted(data) {
    mixpanel.identify(data.User_ID);
    mixpanel.alias(data.Email);
    mixpanel.people.set_once({
        'Account_creation_date':data.Account_creation_date
    });
    mixpanel.people.set({
        $first_name:data.Name,
        $last_name:data.Lastname,
        $email:data.Email
    });
    mixpanel.track('Account_creation_completed', {
        'Name':data.Name,
        'Lastname':data.Lastname,
        'Email':data.Email,
        'Account_creation_date':data.Account_creation_date
    });
}

// Login_clicked
// This event tracks when the user presses the Login link
window.addEventListener('load', (e) => {
    var els1 = document.querySelectorAll('.yotpo-widget-hero-section .yotpo-login-link');
    var els2 = document.querySelectorAll('.yotpo-coupons-redemption-widget-container .yotpo-login-link');
    for(var i = 0; i < els1.length; i++) {
        els1[i].addEventListener('click', (event) => {
            loginClicked({'Previous_action':'rewards'});
        });
    }
    for(var i = 0; i < els2.length; i++) {
        els2[i].addEventListener('click', (event) => {
            loginClicked({'Previous_action':'redeem_points'});
        });
    }
});

function loginClicked(data) {
    mixpanel.track('Login_clicked',data);
}

// Login_completed
// This event tracks when the user complete the proccess of login
document.addEventListener('DOMContentLoaded', (e) => {
    var form = document.querySelectorAll('#customer form');
    var email = document.querySelectorAll('#customer form input#customer_email');
    if(form.length > 0) {
        form[0].addEventListener('submit', (event) => {
            localStorage.setItem('login_email', email[0].value);
        });
    }
});

function loginCompleted(data) {
    mixpanel.identify(data.User_ID);
    mixpanel.alias(data.Email);
    mixpanel.people.set({
        $first_name:data.Name,
        $last_name:data.Lastname,
        $email:data.Email
    });
    mixpanel.track('Login_completed');
}

// Shop_clicked
// This event tracks when the user presses the Shop link (/collections/all-products)
document.addEventListener('DOMContentLoaded', (e) => {
    var els = document.querySelectorAll('[data-link="/collections/all-products"]');
    var dataTrack;
    for(var i = 0; i < els.length; i++){
        els[i].addEventListener('click', (event) => {
            mixpanel.track('Shop_clicked',{'Previous_action':event.target.getAttribute('data-track')});
        });
    }
});

// Our_story_clicked
// This event tracks when the user presses the Our Story link (/pages/our-story)
document.addEventListener('DOMContentLoaded', (e) => {
    var els = document.querySelectorAll('[data-link="/pages/our-story"]');
    for(var i = 0; i < els.length; i++){
        els[i].addEventListener('click', (event) => {
            mixpanel.track('Our_story_clicked',{'Previous_action':event.target.getAttribute('data-track')});
        });
    }
});

// Rewards_clicked
// This event tracks when the user presses the Rewards link (/pages/better-rewards)
document.addEventListener('DOMContentLoaded', (e) => {
    var els = document.querySelectorAll('[data-link="/pages/better-rewards"]');
    for(var i = 0; i < els.length; i++){
        els[i].addEventListener('click', (event) => {
            rewardsClicked({'Previous_action':event.target.getAttribute('data-track')});
        });
    }
});
function rewardsClicked(data) {
    mixpanel.track('Rewards_clicked',data);
}

// FAQ_clicked
// This event tracks when the user presses the FAQs link (/pages/faq)
document.addEventListener('DOMContentLoaded', (e) => {
    var els = document.querySelectorAll('[data-link="/pages/faq"]');
    for(var i = 0; i < els.length; i++){
        els[i].addEventListener('click', (event) => {
            mixpanel.track('FAQ_clicked',{'Previous_action':event.target.getAttribute('data-track')});
        });
    }
});

// Blog_clicked
// This event tracks when the user presses the Blog link (/blogs/the-better-blog)
document.addEventListener('DOMContentLoaded', (e) => {
    var els = document.querySelectorAll('[data-link="/blogs/the-better-blog"]');
    for(var i = 0; i < els.length; i++){
        els[i].addEventListener('click', (event) => {
            mixpanel.track('Blog_clicked',{'Previous_action':event.target.getAttribute('data-track')});
        });
    }
});

// Search_clicked
function searchClicked(data) {
    mixpanel.track('Search_clicked',data);
}

// Search_completed
function searchCompleted(data) {
    mixpanel.track('Search_completed',data);
}

// Store_locator_clicked
// This event tracks when the user presses the Store Locator link (/pages/store-locator)
document.addEventListener('DOMContentLoaded', (e) => {
    var els = document.querySelectorAll('[data-link="/pages/store-locator"]');
    for(var i = 0; i < els.length; i++){
        els[i].addEventListener('click', (event) => {
            storeLocatorClicked({'Previous_action':event.target.getAttribute('data-track')});
        });
    }
});
function storeLocatorClicked(data) {
    mixpanel.track('Store_locator_clicked',data);
}

// Open_chat_clicked
// This event tracks when the user presses the Open Chat link (custom button, no widget)
function openChatClicked(data) {
    mixpanel.track('Open_chat_clicked',data);
}

//Product_clicked
function productClicked(data) {
    mixpanel.track('Product_clicked',data);
}

// Add_to_cart_clicked
// const reviewsNavigated = (data) => {
//   mixpanel.track('Reviews_navigated', data);
// }

// addToCartTrack
// This event tracks when the user add main product from product page
// the variable "data" is a JSON generated in the product form
function addToCartTrack(data) {
    mixpanel.track('Add_to_cart_clicked',data);
}

// Cart_clicked
// This event tracks when the user presses the Cart link
function cartClicked(data,place=null) {
    place = place!=null ? ({'Previous_action':place}) : ({'Previous_action':'no-track'});
    data = {...place,...data};
    mixpanel.track('Cart_clicked',data);
}

// Get MixPanel ID
// This ID is assigned to local storage and captured in the checkout to use in the function identify in the checkout process
if (localStorage.getItem('mp_distinct_id') === null) {
    localStorage.setItem('mp_distinct_id',mixpanel.get_distinct_id());
}

// Checkout_clicked
// This event tracks when the user presses the Checkout link in the cart
function checkoutClicked(data,place=null) {
    let codeDiscount = getCookie('discount_code');
    if(codeDiscount) {
      let dataDiscount =  {
        'Discount_code_applied':true,
        'Discount_code':codeDiscount
      }
      data = {...data,...dataDiscount};
    }
    place = place != null ? ({'Previous_action':place}) : ({'Previous_action':'cart'});
    data = {...data,...place};
    mixpanel.track('Checkout_clicked',data);
}

// Quiz_clicked
// This event tracks when the user presses the Quiz link
document.addEventListener('DOMContentLoaded', (e) => {
    var els = document.querySelectorAll('[data-link="/pages/better-hair-quiz"]');
    var dataTrack;
    for(var i = 0; i < els.length; i++){
        els[i].addEventListener('click', (event) => {
            quizClicked({'Previous_action':event.target.getAttribute('data-track')});
        });
    }
});
function quizClicked(data) {
    mixpanel.track('Quiz_clicked',data);
}

// Quiz_started
// This event tracks when the user presses the button "Take the quiz"
function quizStarted() {
    mixpanel.track('Quiz_started');
}

// Quiz_completed
// This event tracks when the user finished the quiz
function quizComplete() {
    mixpanel.track('Quiz_completed');
}

// Reviews_navigated
// This event tracks when the customer navigates review on home page
window.addEventListener('load', (e) => {
    const check = () => {
        window.setTimeout(checkExist, 1000);
    }
    const checkExist = () => {
        let els = document.querySelectorAll('.yotpo_previous,.yotpo_next');
        if(els.length > 0) {
            let navLeft = document.querySelectorAll('.yotpo_previous'),
                navRight = document.querySelectorAll('.yotpo_next');
            for (let i = 0; i < navLeft.length; i++) {
                navLeft[i].addEventListener('click', (evt) => {
                    console.log('click prev');
                    reviewsNavigated({'Press direction':'left-previous'});
                });
            }
            for (let i = 0; i < navRight.length; i++) {
                navRight[i].addEventListener('click', (evt) => {
                    console.log('click next');
                    reviewsNavigated({'Press direction':'right-next'});
                });
            }
            clearCheck();
        } else {
            //console.log('No existe');
        }
    }
    const clearCheck = () => {
        window.clearTimeout(check);
    }
    check();
});
const reviewsNavigated = (data) => {
    mixpanel.track('Reviews_navigated', data);
}

// Article_clicked
// This event track when the customer click in a blog article
function articleClicked(data) {
    mixpanel.track('Article_clicked', data);
}

// Home_clicked
// This event tracks when the user presses the Home link
function homeClicked() {
    mixpanel.track('Home_clicked');
}

// Social_clicked
// This event tracks when the user presses some icon of RRSS
function socialClicked(data) {
    mixpanel.track('Social_clicked',data);
}

// Email_entered
// This event track when a user is subscribe in Klaviyo form
function emailEntered(data) {
    mixpanel.identify(localStorage.getItem('mp_distinct_id'));
    mixpanel.alias(data.Email);
    mixpanel.people.set({
        $email:data.Email,
        'Klaviyo subscribe': true
    });
    mixpanel.track('Email_entered',data);
}
  
window.addEventListener("klaviyoForms", (e) => {
    if (e.detail.type == 'submit') {
        emailEntered({
            'Email': e.detail.metaData.$email,
            'Klaviyo form ID': e.detail.formId,
            'Klaviyo form name': e.detail.metaData.$source
        });
    }
});

// PP_Reviews_clicked
// This event track when a Customer click over starts reviews on product pages (link to review module)
document.addEventListener('DOMContentLoaded', (e) => {
    var els = document.querySelectorAll('.product_section .yotpo.bottomLine');
    for(var i = 0; i < els.length; i++){
        els[i].addEventListener('click', (event) => {
            ppReviewsClicked();
        });
    }
});
function ppReviewsClicked() {
    mixpanel.track('PP_Reviews_clicked');
}

// PP_Afterpay_clicked
// This event track when a Customer click Afterpay on product pages (link to popup with info Afterpay)
document.addEventListener('DOMContentLoaded', (e) => {
    var els = document.querySelectorAll('.afterpay-wrapper');
    for (var i = 0; i < els.length; i++) {
        els[i].addEventListener('click', (event) => {
            ppAfterpayClicked();
        })
    }
});
function ppAfterpayClicked() {
    mixpanel.track('PP_Afterpay_clicked');
}

// PP_menu_navigated
// This event track when a Customer click on any of the product page menu options
function ppMenuNavigated(data) {
    mixpanel.track('PP_menu_navigated',data);
}

// ACC_Order_history_clicked
// This event track when a Customer clicks on history in account page
function accOrderHistoryClicked() {
    mixpanel.track('ACC_Order_history_clicked');
}

// ACC_Order_visited
// this event track when a customer clicks on an specific order within their list
document.addEventListener('DOMContentLoaded', (e) => {
    var els = document.querySelectorAll('.order-link a');
    for(let i=0;i<els.length;i++) {
        els[i].addEventListener('click', (event) => {
            accOrderVisited();
        });
    }
});
function accOrderVisited() {
    mixpanel.track('ACC_Order_visited');
}

// Code_copied
// Customer click redeem on coupon
window.addEventListener('load', (e) => {
    var els = document.querySelectorAll('.yotpo-redemption-option-redeem-button button');
    for(let i=0;i<els.length;i++) {
        els[i].addEventListener('click', (event) => {
            let code = els[i].getAttribute("aria-label");
            let conf = document.querySelectorAll('.yotpo-redemption-confirmation-option-confirm');
            for(let i=0;i<conf.length;i++) {
                conf[i].addEventListener('click', (e) => {
                    codeCopied(code);
                });
            }
        });
    }
});
function codeCopied(c) {
    mixpanel.track('Code_copied', {
        'Code': c
    });
    mixpanel.people.increment('Coupons_redeemed');
}

// ACC_Refer_clicked
// This event track when a Customer clicks on refer friends in account page
function accReferClicked() {
    mixpanel.track('ACC_Refer_clicked');
}

// ACC_Help_clicked
// This event track when a Customer clicks on help in account page
function accHelpClicked() {
    mixpanel.track('ACC_Help_clicked');
}

// ACC_Subscriptions_clicked
// This event track when a Customer clicks on manage subscriptions
function accSubscriptionsClicked() {
    mixpanel.track('ACC_Subscriptions_clicked');
}

// ACC_Addresses_clicked
// This event track when a Customer clicks on add a new address
function accAddressesClicked() {
    mixpanel.track('ACC_Addresses_clicked');
}

// ACC_Add_address_completed
// This event track when a customer add a address
document.addEventListener('DOMContentLoaded', (e) => {
    var els = document.querySelectorAll('#address_form_new');
    for (var i = 0; i < els.length; i++) {
        els[i].addEventListener('submit', (event) => {
            accAddAddressCompleted({
                'City': document.getElementById('address_city_new').value,
                'Postal_code': document.getElementById('address_zip_new').value,
                'Phone': document.getElementById('address_phone_new').value
            });
        })
    }
});
function accAddAddressCompleted(data) {
    mixpanel.track('ACC_Add_address_completed', data);
}
